module.exports = __webpack_public_path__ + "static/img/Platinum1.a61e9bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Platinum1.svg
// module id = wHAV
// module chunks = 38